import { createContext } from 'react';

export const RendererReadOnlyContext = createContext<boolean>(true);
